import { render, staticRenderFns } from "./MInput.vue?vue&type=template&id=996cf4ac&scoped=true&lang=pug&"
import script from "./MInput.vue?vue&type=script&lang=js&"
export * from "./MInput.vue?vue&type=script&lang=js&"
import style0 from "./MInput.vue?vue&type=style&index=0&id=996cf4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996cf4ac",
  null
  
)

export default component.exports